export function displayCPF(originalCPF: string): string {
  return originalCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export const createString = (length: number, char: string): string => {
  let string = '';

  (length > 0) && [...Array(length)].fill('').forEach(() => {
    string += char;
  });

  return string;
};

export const lengthWithoutSpaces = (string: string): number => {
  return string.replace(new RegExp(' ', 'g'), '').length;
};

export const replaceString = (string: string, target: string, replace: string): string => {
  const regex = `[${target}]`;

  return string && string.replace(new RegExp(regex, 'g'), replace);
};

export const createSlug = (string: string) => {
  return string && replaceString(string, ' ', '-').toLocaleLowerCase();
};
